import React from 'react'
import PropTypes from 'prop-types'
import { HippostdHtml } from '../blogArticle/componentTypes/HippostdHtml.jsx'
const Disclosures = ({ page }) => {
  const document = page?.getDocument()
  const data = document?.getData()
  const { detailDocument } = data
  const value = page.getContent(detailDocument?.$ref)?.model?.data?.disclosures
    ?.value

  return value ? <DisclosuresRendering content={value} /> : null
}
Disclosures.propTypes = {
  page: PropTypes.object,
}

export const DisclosuresRendering = ({ content = '' }) => {
  return (
    <div className="Disclosure u-printHidden u-decoBackgroundNeutral05">
      <div className="u-sizeConstrained  u-paddingVert12gu">
        <h2>Disclosures</h2>
        <HippostdHtml value={content} classNames="u-paddingTop6gu" />
      </div>
    </div>
  )
}
DisclosuresRendering.propTypes = {
  content: PropTypes.string,
}

export { Disclosures }
